import { styled } from "@sourceful/shared-components";
import { SanityInformationCardSection } from "@sourceful/shared-types";
import toRem from "@styles/postprocess/conversion/to-rem";
import { BasePageSection } from "../BasePageSection";
import React from "react";
import InformationCard from "@components/informationCard";

const InformationCardSectionWrapper = styled("div", {
  margin: "0 auto",
  marginTop: toRem(70),
  marginBottom: toRem(40),
  display: "flex",
  flexDirection: "column",
  rowGap: "$block_xl1",

  "@lg": {
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    "> *": {
      flex: "0 0 calc(50% - $space$inline_m1)",
    },
  },
});

interface InformationCardSectionProps {
  section: SanityInformationCardSection;
}

export const TechnicalContentSection = ({ section }: InformationCardSectionProps) => {
  return (
    <BasePageSection section={section}>
      <InformationCardSectionWrapper>
        {section.informationCards.map((item, index) => (
          <InformationCard informationCard={item} key={`${item._key}-${index}`} />
        ))}
      </InformationCardSectionWrapper>
    </BasePageSection>
  );
};

export default TechnicalContentSection;
